require('./index.css')

var angular = require('angular');

var app_deps = [
    require('./api'),
    require('./helpers'),
    require('./layout'),
    require('./login'),
    require('./json_editor'),
    require('./user_manager'),
    require('./charts'),
    require('./forms'),
];
var app = angular.module('amt_admin', app_deps.map(x => x.default));

app.run(['$rootScope', '$state', '$stateParams', function ($rootScope, $state, $stateParams) {
        $rootScope.$on("$stateChangeError", console.log.bind(console));
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
}]);


app.run(['APP_CONFIG', '$rootScope', function(APP_CONFIG, $rootScope){
    $rootScope.$APP_CONFIG = APP_CONFIG
}]);

app.config(['$stateProvider', function ($stateProvider) {
    $stateProvider
        .state('amt.developer', {
                url: '/developer',
                abstract: true,
                template: '<div ui-view></div>',
                data: {
                    role: 'admin',
                    priority: 1000
                },
                menu: {
                    position: 'top',
                    fa_icon: 'gears',
                    childs: [
                        {state: 'amt.developer.services_methods'}
                    ]
                }
            }
        )
}]);

app.filter('prettyJSON', function () {
    function prettyPrintJson(json) {
      return JSON ? JSON.stringify(json, null, '  ') : 'your browser doesnt support JSON so cant pretty print';
    }
    return prettyPrintJson;
});

app.filter('filesize', function () {
  var units = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB'
  ];

  return function( bytes, precision ) {
    if ( isNaN( parseFloat( bytes )) || ! isFinite( bytes ) ) {
      return '?';
    }

    var unit = 0;

    while ( bytes >= 1024 ) {
      bytes /= 1024;
      unit ++;
    }

    return bytes.toFixed( + precision ) + ' ' + units[ unit ];
  };
});

app.filter('reverse', function() {
  return function(items) {
    return items.slice().reverse();
  };
});

app.filter('toArray', function() { return function(obj) {
    if (!(obj instanceof Object)) return obj;
    return _.map(obj, function(val, key) {
        return Object.defineProperty(val, '$key', {__proto__: null, value: key});
    });
}});

export default app.name;


